<template>
  <div class="content-block">
    <div class="article-wrap">
      <div class="article-change">
        <div class="article-change-title">NEWS</div>
        <ul class="article-change-items">
          <li><a href="/news">官網活動</a></li>
          <li><a href="/event">實體店活動</a></li>
          <li class="active">
            <a href="/mag">趨勢文章</a>
          </li>
        </ul>
      </div>
      <div class="article-info">
        <ul class="trend-list row">
          <li v-for="item in list" :key="item.ID" class="col-12 col-md-6">
            <a :href="'/mag/article/' + item.ID">
              <div class="img-ratio">
                <img class="img-fluid" :src="item.CoverImage" :alt="item.Title" />
              </div>
            </a>
            <p class="date">{{ item.PostTime }}</p>
            <a :href="'/mag/article/' + item.ID">
              <h3>{{ item.Title }}</h3>
            </a>
            <p>{{ item.Summary }}</p>
            <div class="tags">
              <span v-for="(tag, index) in item.Tag" :key="index">
                <a :href="'/mag/' + tag">#{{ tag }}</a>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Pagination v-if="totalPage" :total-page="totalPage" />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Pagination from '@global/components/common/pagination/PaginationLayout.vue';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

const { getArticleListAPI } = useAxiosAPI();

const list = ref([]);
const nowPage = ref(1);
const totalPage = ref(null);

function getList() {
  const nowLocation = window.location.toString();

  if (nowLocation.indexOf('?') !== -1) {
    const args = nowLocation.split('?')[1].split('&');
    for (let i = 0; i < args.length; i++) {
      if (args[i].indexOf('P=') !== -1) {
        nowPage.value = parseInt(args[i].replace('P=', ''));
      }
    }
  } else {
    nowPage.value = 1;
  }

  getArticleListAPI({
    params: {
      Category: 'ALL',
      Limit: 6,
      Page: nowPage.value,
      Content: 1,
    },
  })
    .then((res) => {
      if (res.data.Code === 200) {
        list.value = res.data.Response.Data;
        totalPage.value = res.data.Response.PageCount;
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

getList();
</script>
